import { observable, action } from 'mobx';
import { getToDoList } from '@/services/apis';
import { frameScheme, buildPath } from '@/utils';

// todo项
export interface ToDoItem {
  id: number; // 待办事项ID
  notifyMsg: string; // 待办事项的名称
  callbackUrl: string; // 待办事项处理的跳转url
  optFlag: number; // 1为复制操作链接，0为立即处理
  status: number; // 1为未处理，2为已处理
}

/**
 * 待办事项
 */
export default class todoStore {
  @observable toDoList: ToDoItem[] = [];

  @observable isIntercept = true;

  @observable st = '';

  @observable title = '';

  @observable msg = '';

  // 更改数据
  @action.bound
  setData(data: any) {
    for (const key in data) {
      this[key] = data[key];
    }
  }

  /**
   * 获取待办事项
   */
  @action.bound
  getToDoList = async (
    clientId: string,
    uid: number,
    lt?: string
  ): Promise<void> => {
    const param = {
      clientId,
      uid,
      lt
    };
    try {
      const data: any = await getToDoList(param);
      const {
        isIntercept, todoList = [], st, title
      } = data;
      const processedRes = this.processData(todoList);
      this.setData({
        toDoList: processedRes,
        isIntercept,
        st,
        title
      });
      if (!isIntercept && todoList.length === 0) {
        const path = buildPath('mtsso://www.meituan.com/check/todo', {
          status: 1,
          lt,
          st
        });
        if (/com\.meituan\.sso/.test(window.navigator.userAgent)) {
          frameScheme(path);
        }
        console.log('/intercept/todo---auto jump');
      }
    } catch (e) {
      console.error(e);
      if (e.code === 10005) {
        const path = buildPath('mtsso://www.meituan.com/check/todo', {
          status: -1,
          msg: e.message
        });
        if (/com\.meituan\.sso/.test(window.navigator.userAgent)) {
          frameScheme(path);
        }
        console.log('/intercept/todo---overdue');
      }
    }
  };

  /**
   * 数据处理
   */
  private processData = (list) => {
    const res = JSON.parse(JSON.stringify(this.toDoList));
    const oldIds = this.toDoList.map(item => item.id);
    const newListMap = {};
    for (const o of list) {
      newListMap[o.id] = o;
    }
    for (const item of res) {
      const { id } = item;
      if (!(id in newListMap)) {
        item.status = 2;
      } else {
        const { callbackUrl, notifyMsg, msgType } = newListMap[id];
        item.callbackUrl = callbackUrl;
        item.notifyMsg = notifyMsg;
        item.msgType = msgType;
      }
    }
    for (const item of list) {
      const {
        id, notifyMsg, callbackUrl, optFlag, msgType
      } = item;
      if (!(oldIds.includes(id))) {
        res.push({
          id,
          notifyMsg,
          callbackUrl,
          optFlag,
          status: 1,
          msgType
        });
      }
    }
    return res;
  };
}
